import { createSlice } from '@reduxjs/toolkit';
import { useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { fetchFaqsThunk } from 'shared/lib';
import { FAQModel, FAQModelSchema } from 'entities/faq';
import BaseError from '../../../utils/base-error';

export type FAQsBlockState = {
    loaded: boolean
    errors: BaseError[]
    faqs: FAQModel[]
}

const initialState: FAQsBlockState = {
    loaded: false,
    errors: [],
    faqs: [],
};

// eslint-disable-next-line import/prefer-default-export
export const fAQsBlockSlice = createSlice({
    name: 'fAQsBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchFaqsThunk.fulfilled, (state, action) => {
            const response = action.payload;

            if (response instanceof BaseError) {
                // TODO
            } else {
                // Валидация
                try {
                    state.faqs = response.data.data?.map(({
                        documentId,
                        question,
                        answer,
                    }) => FAQModelSchema.parse({
                        uid: documentId,
                        question,
                        answer,
                    })) || [];
                    state.loaded = true;
                } catch (e) {
                    // return new BaseError(400, String(e));
                    // TODO
                }
            }
        });
    },
});

export const useFAQsBlockState = () => useAppSelector((store) => store.fAQsBlock);
